import React, { createContext, useReducer } from 'react';
import { PaginationType } from '@cloudez/cloudez-design-system';
import { Domain } from 'types/domain';
import reducer from './reducer';
import { setLoading, getDomains, updateDomain } from './actions';

export interface DomainListingState extends PaginationType {
  domains: Domain[];
  loading: boolean;
  errors: any;
  setLoading(value: boolean): void;
  getDomains(
    page: string | number,
    search: string,
    filter: any,
    order: any,
    ctrl: AbortController,
  ): Promise<void>;
  updateDomain(field: string, value: any, id?: number | string): Promise<void>;
}

// initial state
const initialState = {
  domains: null,
  count: null,
  previous: null,
  current: null,
  next: null,
  loading: true,
  errors: null,
};

// context
export const DomainListingContext = createContext<DomainListingState>(
  initialState as DomainListingState,
);

// provider
export const DomainListingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    reducer,
    initialState as DomainListingState,
  );

  return (
    <DomainListingContext.Provider
      value={{
        // state
        domains: state.domains,
        count: state.count,
        previous: state.previous,
        current: state.current,
        next: state.next,
        loading: state.loading,
        errors: state.errors,

        // actions
        setLoading: value => setLoading(dispatch, value),
        getDomains: async (page, search, filter, order, ctrl) =>
          await getDomains(dispatch, page, search, filter, order, ctrl),
        updateDomain: async (field, value, id) =>
          await updateDomain(dispatch, field, value, id),
      }}
    >
      {children}
    </DomainListingContext.Provider>
  );
};
